'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/Chats.es.js";
const t = a.forwardRef((a$1, e$1) => /* @__PURE__ */ a.createElement(p, { ref: e$1, ...a$1, weights: e }));
t.displayName = "ChatsIcon";
const n = t;
export {
  n as Chats,
  t as ChatsIcon
};
